
import { create } from 'zustand';
import { draftsApi, type TicketDraft } from '@/shared/api/drafts';

interface DraftState {
  draft: TicketDraft | null;
  loaded: boolean;
  fetchDraft: () => Promise<void>;
  setDraft: (draft: TicketDraft | null) => void;
}

export const useDraftStore = create<DraftState>((set) => ({
  draft: null,
  loaded: false,
  fetchDraft: async () => {
    try {
      const res = await draftsApi.get();
      set({ draft: res.data ?? null, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
  setDraft: (draft) => set({ draft, loaded: true }),
}));
